export enum DebtorType {
    insurer = 'insurer',
    notApplicable = 'notApplicable',
    patient = 'patient',
    unknown = 'unknown',
}
